export default theme => ({
  readOnly: {
    backgroundColor: '#f5f5f5',
    borderRadius: 4,
    padding: '6px 10px',
    whiteSpace: 'pre-wrap',
  },
});
